// Fallback covers for real courses that don't have a thumbnail_url set yet.
// Matched by title keywords since these courses predate the cover-image feature.
const FALLBACK_COVERS: { test: (title: string) => boolean; file: string }[] = [
  { test: (t) => t.includes('openrocket'), file: 'introduccion-a-openrocket.jpg' },
  { test: (t) => t.includes('clasificacion') && t.includes('motor'), file: 'clasificacion-de-motores.jpg' },
  { test: (t) => t.includes('motor') && t.includes('espacial'), file: 'motores-espaciales.jpg' },
  { test: (t) => t.includes('estabilidad') && t.includes('cohete'), file: 'estabilidad-de-un-cohete.jpg' },
  { test: (t) => t.includes('riel') || (t.includes('empuje') && t.includes('peso')), file: 'velocidad-salida-riel.jpg' },
  { test: (t) => t.includes('paracaidas'), file: 'fisica-del-paracaidas.jpg' },
  { test: (t) => t.includes('modelismo') && t.includes('espacial'), file: 'modelismo-espacial.jpg' },
];

const DEFAULT_PLACEHOLDER = 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?q=80&w=800&auto=format&fit=crop';

function normalize(title: string): string {
  return title
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '');
}

export function getCourseCoverUrl(course: { title?: string | null; thumbnail_url?: string | null }): string {
  if (course.thumbnail_url) return course.thumbnail_url;

  const title = normalize(course.title ?? '');
  const match = FALLBACK_COVERS.find((c) => c.test(title));
  if (match) return `/covers/${match.file}`;

  return DEFAULT_PLACEHOLDER;
}

// Whether a real cover image exists (set thumbnail_url, or a matched fallback) as opposed to
// falling back to the generic stock placeholder — used where the UI shows a stylized
// placeholder instead of the stock photo when there's no real cover.
export function hasCourseCover(course: { title?: string | null; thumbnail_url?: string | null }): boolean {
  if (course.thumbnail_url) return true;
  const title = normalize(course.title ?? '');
  return FALLBACK_COVERS.some((c) => c.test(title));
}
